import AxiosClient from "../../../services/axios.services";

class ObjectiveHistoryServices {
 
  getObjectiveHistory = (data) =>
    AxiosClient.post("/api/app/Monitor_Evaluaciones_Objetivos_Historial/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
 
}

export default new ObjectiveHistoryServices();
